@if (hasDisplayConfiguration) {
  <div [class]="globalStyleClass" data-cy="pnc-detail-solution">
    @if (showAdditionalFields) {
      <div class="pnc-detail-solution-column-container pnc-detail-form-input-old-part-number-change-material">
        <div>
          <div class="pnc-detail-body-output-field-label detail">
            <span data-cy="pnc-detail-solution-label-old-part-number">Old part number</span>
          </div>
          <div class="pnc-detail-body-output-field-value detail"
          data-cy="pnc-detail-solution-old-part-number">{{$safeNavigationMigration(configuration?.data.oldPartNumber) | prettyPrintMaterialNumber}}</div>
        </div>
        <div>
          @if (this.showInViewMode && !showSpecialistSolution) {
            <div></div>
            <div class="component-view-wrapper pnc-details-solution-solution-spp-wrapper">
              <div [ngClass]="{'inverted': showInViewMode}">
                <div class="pnc-detail-solution-solution-spp-label">Supplying Packing Plant:</div>
                <div class="pnc-detail-body-output-field-solution-value">{{prettySolutionSupplyingPackingPlant}}</div>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (showFlashingFlag && !showInViewSolutionMode && !showInViewMode) {
      <div class="pnc-detail-body-output-field-value pnc-detail-solution-ee-parts-requires-flashing detail">
        <i class="iwp-icon-gen_info_warning"></i>
        <span data-cy="pnc-detail-solution-label-requires-flashing">Does the solution demand software flashing?</span>
      </div>
    }
    <ng-container *ngTemplateOutlet="pncSolutionTemplate"></ng-container>
    @if (showAdditionalFields) {
      <div class="pnc-detail-body-output-field-label detail">
        <span data-cy="pnc-detail-solution-solved-by">Solved by</span>
      </div>
      <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email detail"
      data-cy="pnc-detail-solution-solved-by-email">{{$safeNavigationMigration(configuration?.data.solvedBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
    }
    @if (showInViewSolutionMode) {
      <div class="pnc-detail-body-output-field-label pnc-detail-body-output-field-value-tried-by"><span
      data-cy="pnc-detail-solution-tried-by-label">Tried by</span></div>
      <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email"
      data-cy="pnc-detail-solution-tried-by-value">{{$safeNavigationMigration(configuration?.data.solvedBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
    }
    @if (showViewSolutionEEParts) {
      <ng-container *ngTemplateOutlet="pncSolutionEEParts"></ng-container>
    }
  </div>
}

@if (showSolutionSpecialist) {
  <ng-container *ngTemplateOutlet="pncSolutionEESpecialist"></ng-container>
}

<!-- PNC EE SOLUTION DETAIL TEMPLATE -->
<ng-template #pncSolutionEEParts>
  <div class="pnc-detail-solution-ee-parts-wrapper">
    @if (!showSpecialistSolution) {
      <div>
        <div class="pnc-detail-body-output-field-label detail pnc-detail-solution-ee-parts-title">
          <span data-cy="pnc-detail-solution-ee-parts-title">EE validation</span>
        </div>
        <div class="pnc-detail-solution-ee-parts-block-wrapper">
          <div class="pnc-detail-solution-ee-parts-iLevel-wrapper">
            <div class="pnc-detail-body-output-field-label detail">
              <span data-cy="pnc-detail-solution-ee-parts-iLevel-label">I-level</span>
            </div>
            <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value detail"
            data-cy="pnc-detail-solution-ee-parts-iLevel-value">{{$safeNavigationMigration(configuration?.data.iLevel)  | undefinedValue}}</div>
          </div>
          <div>
            <div class="pnc-detail-body-output-field-label detail">
              <span data-cy="pnc-detail-solution-ee-parts-validatedBy-label">Validated by</span>
            </div>
            <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email detail"
            data-cy="pnc-detail-solution-ee-parts-validatedBy-value">{{$safeNavigationMigration(configuration?.data.validatedBy)  | prettyPrintUpdatedBy | undefinedValue}}</div>
          </div>
        </div>
      </div>
    }
    <div class="pnc-solution-ee-additional-information"
      data-cy="pnc-solution-ee-additional-information">
      <app-input-textarea
        [initialValue]="eeSolutionAdditionalInformation | undefinedValue"
        [invertedColor]="invertColors"
        [showViewMode]="showInViewMode || showInViewSolutionMode"
        baseCypressTag="pnc-detail-solution-ee-additional-information"
        height="88"
        label="Additional information"
      maxLength="400"></app-input-textarea>
    </div>
    @if (showSpecialistSolution) {
      <div class="pnc-detail-body-output-field-label pnc-detail-body-output-field-value-tried-by"><span
      data-cy="pnc-detail-solution-tried-by-label">Tried by</span></div>
      <div class="pnc-detail-body-output-field-value pnc-detail-body-output-field-value-email"
      data-cy="pnc-detail-solution-tried-by-value">{{$safeNavigationMigration(configuration?.data.solvedBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
    }
  </div>
</ng-template>

<!-- PNC SOLUTION/SOLVE TEMPLATE -->
<!-- TODO: Recover to isolate into to a separate component like the additional lot number -->
<ng-template #pncSolutionTemplate>
  @if (showEESpecialistValidation) {
    @if (showRequiresFlashingToggleInViewMode) {
      <div class="pnc-detail-trial-title-requires-flashing"
      data-cy="pnc-detail-trial-title-requires-flashing">Solution {{getCurrentPNCCount}}</div>
    }
    @if (this.showInViewMode === false && this.showInViewSolutionMode === false) {
      @if (isPncTypePartnerOrPlanner) {
        <div class="component-view-wrapper pnc-details-solution-alternative-spp-wrapper">
          <div>
            <div class="pnc-detail-solution-alternative-spp-label">Supplying Packing Plant:</div>
            <div class="pnc-detail-body-output-field-value">{{prettySolutionSupplyingPackingPlant}}</div>
          </div>
          <button class="btn-primary" style="margin-right: 12px;" (click)="openPopup()">Change plant</button>
        </div>
      }
      <div class="pnc-solution-checkbox-wrapper" data-cy="pnc-solution-checkbox-wrapper">
        <input type="checkbox"
          [checked]="showRequiresFlashingToggleInViewMode"
          [disabled]="showRequiresFlashingToggleInViewMode"
          data-cy="checkbox-eeSpecialist"
          class="pnc-solution-checkbox-input"
          (change)="toggleRequiresFlashing($event)"/><span [ngClass]="checkboxTextStyle"
        data-cy="pnc-solution-checkbox-text">Does the solution demand software flashing?</span>
      </div>
    }
  }

  <div class="pnc-solution-new-part-number-container"
    data-cy="pnc-solution-new-part-number-container"
    [ngClass]="{'pnc-solution-new-part-number-container-ee-solution': showRequiresFlashingToggleInViewMode}">
  <app-part-number-changes-detail-pnc-solution-new-part-number (newPartChange)="newPartChange($event)"
    [isSolutionSpecialist]="showSpecialistSolution"
    [isInViewMode]="showInViewMode || showInViewSolutionMode"
    [isDetailSolvedTrial]="showInViewSolutionMode"
                                                                     [materialWarningLevel]="warningLevel($safeNavigationMigration(configuration?.
                                                                     displayConfiguration?.materialInput.required))"
    [material]="$safeNavigationMigration(configuration?.data?.newPartNumber)"
                                                                     [quantityWarningLevel]="warningLevel($safeNavigationMigration(configuration?.
                                                                     displayConfiguration?.quantityInput.required))"
    [supplyingPackingPlantCodeChange]="supplyingPackingPlantCodeChange"
    [supplyingPackingPlantCode]="currentPackingPlant">
  </app-part-number-changes-detail-pnc-solution-new-part-number>
  @for (additionalParts of additionalPartNumbers; track trackByItem(index, additionalParts); let index = $index) {
    <app-part-number-changes-detail-pnc-solution-new-part-number
      (deleteClick)="removePartNumber(additionalParts)"
      (newPartChange)="additionalPartChange($event)"
      [isSolutionSpecialist]="showSpecialistSolution"
      [additionalIndex]="index + 1"
      [isInViewMode]="showInViewMode || showInViewSolutionMode"
      [isDetailSolvedTrial]="showInViewSolutionMode"
                    [materialWarningLevel]="warningLevel($safeNavigationMigration(configuration?.
                                                                     displayConfiguration?.materialInput.required))"
      [material]="additionalParts"
                    [quantityWarningLevel]="warningLevel($safeNavigationMigration(configuration?.
                                                                     displayConfiguration?.quantityInput.required))"
      [supplyingPackingPlantCodeChange]="supplyingPackingPlantCodeChange"
      [supplyingPackingPlantCode]="currentPackingPlant">
    </app-part-number-changes-detail-pnc-solution-new-part-number>
  }

  @if (this.showInViewMode === false && this.showInViewSolutionMode === false) {
    <app-pnc-add-addition-input-button (addAdditionalInput)="addPartNumber()"
      [disabled]="!canAddAdditionalParts"
      [tooltipIsDisabled]="disableComponent"
      [tooltipMessage]="tooltipMessage"
      baseDataCy="pnc-solution-add-additional-part-number"
      class="additional"
    label="Add additional part number"></app-pnc-add-addition-input-button>
  }

  @if (this.showInViewSolutionMode && !showSpecialistSolution) {
    @if (additionalPartNumbers.length % 2 == 0) {
      <div></div>
    }
    <div class="component-view-wrapper pnc-details-solution-solution-spp-wrapper">
      <div [ngClass]="{'inverted': showInViewMode}">
        <div class="pnc-detail-solution-solution-spp-label">Supplying Packing Plant:</div>
        <div class="pnc-detail-body-output-field-solution-value">{{prettySolutionSupplyingPackingPlant}}</div>
      </div>
    </div>
  }

  @if (!showSpecialistSolution) {
    <div class="pnc-solution-additional-information"
      data-cy="pnc-detail-solution-additional-information">
      <app-input-textarea (inputValueChange)="setAdditionalInformation($event)"
                                [initialValue]="initialValuePipe(configuration?.displayConfiguration.additionalInformation.displayMode,
                $safeNavigationMigration(configuration?.data?.additionalInformation))"
        [invertedColor]="showInViewMode"
        [showViewMode]="showInViewMode || showInViewSolutionMode"
        [warningLevel]="warningLevel($safeNavigationMigration(configuration?.displayConfiguration?.additionalInformation.required))"
        baseCypressTag="pnc-detail-solution-additional-information"
        height="88"
        label="Additional information"
        maxLength="400"
      placeholder="Write an additional information"></app-input-textarea>
    </div>
  }
</div>
</ng-template>

<ng-template #pncSolutionEESpecialist>
  <div class="pnc-detail-form-ee-specialist-solution-wrapper">
    <div class="pnc-form-ee-specialist-i-level-wrapper">
      <app-input-text #iLevelInput
        (inputValueChange)="setILevel($event)"
        (inputStateChange)="iLevelStateChange($event)"
        [messages]="iLevelMessages"
        [validators]="validators.iLevel"
        [isToUpperCaseInputTextValue]="true"
        baseCypressTag="pnc-form-ee-specialist-i-level"
        label="I-level"
        maxLength="14"
        placeholder="e.g. S15A-22-03-520">
      </app-input-text>
    </div>
    <app-input-textarea (inputValueChange)="setAdditionalInformationSolution($event)"
      baseCypressTag="pnc-detail-solution-additional-information"
      height="88"
      label="Additional information"
      maxLength="400"
      placeholder="Write an additional information">
    </app-input-textarea>
  </div>
</ng-template>
